import React, {FC} from "react"
import PropTypes from "prop-types"

import {AdsOfferKind, Deal} from "@irati/types"
import Button from "@irati/ui/src/Button"
import mainTheme from "@irati/ui/src/global/theme"
import Hero from "@irati/ui/src/Hero"
import {RouterLink} from "@irati/ui/src/Link"
import {H5} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import adsService from "@irati/ads/services/ads"
import isRPDeal from "@irati/deals/helpers/deals/isRPDeal"

import PromoSection from "./PromoSection"
import {Content, StyledPill, Thumbnail} from "./styled"

type Props = {
  deal: Deal
  onClick: () => void
}

const HeroPerk: FC<Props> = ({deal, onClick}, {apps}) => {
  const {header, savings, urlSlug, bannerImage, thumbnailImage} = deal
  const url = `/info/${urlSlug}`

  const handleClick = () => {
    adsService.click(deal, AdsOfferKind.HomepageHero)
    onClick()
  }

  const linkApp = isRPDeal(deal) ? apps.FLEXIREWARDS : apps.PERKS

  return (
    <RouterLink to={url} onClick={handleClick} app={linkApp}>
      <Hero bgImg={bannerImage} bgColor={mainTheme.colors.utility.white}>
        {savings?.boostedSavings && (
          <StyledPill
            text={<FormattedMessage id="perks.deals.boostedSaving.boostedAmount.text" />}
            iconType="instant"
            backgroundColor={mainTheme.colors.utility.acid}
          />
        )}

        <Thumbnail src={thumbnailImage} />

        <Content color={!bannerImage ? mainTheme.colors.greys.black : undefined}>
          <PromoSection deal={deal} />
          <H5 marginTop={0.5}>{header}</H5>

          <Button primary marginTop={2}>
            <FormattedMessage id="perks.components.homePageBanner.getThisPerk" />
          </Button>
        </Content>
      </Hero>
    </RouterLink>
  )
}

HeroPerk.contextTypes = {
  apps: PropTypes.object.isRequired
}

export default HeroPerk
